import {
    UtensilsCrossed, Coffee, Scissors, Stethoscope, Dumbbell, GraduationCap,
    Compass, Briefcase, Wrench, Building2, BedDouble, Store,
} from "lucide-react";
import { INDUSTRIES } from "../data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const ICONS = {
    UtensilsCrossed, Coffee, Scissors, Stethoscope, Dumbbell, GraduationCap,
    Compass, Briefcase, Wrench, Building2, BedDouble, Store,
};

export const Industries = () => (
    <section id="industries" className="bg-brand-cream py-16 sm:py-24 lg:py-32" data-testid="industries-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
            <SectionHeading
                chapter="05"
                kicker="Who It's For"
                title="Built for businesses that live on local customers."
                lead="If your customers find you by searching, scrolling or asking around — this system was designed for you."
                testid="industries-heading"
            />
            <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                {INDUSTRIES.map((ind, i) => {
                    const Icon = ICONS[ind.icon];
                    return (
                        <Reveal key={ind.name} delay={(i % 4) * 0.06}>
                            <div
                                data-testid={`industry-card-${i}`}
                                className="group flex h-full items-center gap-4 rounded-2xl border border-brand-brown/10 bg-white p-5 transition-all duration-300 hover:-translate-y-1 hover:border-brand-orange/40 hover:shadow-[0_16px_32px_-16px_rgba(53,24,13,0.25)]"
                            >
                                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-orange-tint text-brand-orange transition-colors duration-300 group-hover:bg-brand-orange group-hover:text-white">
                                    <Icon size={19} aria-hidden="true" />
                                </span>
                                <span className="text-sm font-semibold leading-snug text-brand-brown">{ind.name}</span>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
